import { render, staticRenderFns } from "./createPaxelMarketBasicService.vue?vue&type=template&id=4a35f654&"
import script from "./createPaxelMarketBasicService.vue?vue&type=script&lang=js&"
export * from "./createPaxelMarketBasicService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports